import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { FacetProfile, FieldDefinition } from '@stylehaven/components';
import { GenericOverviewContainerSandboxService } from '../../containers/generic-overview-container-sandbox.service';
import { RecordType } from '../../record/entities/metadata.entity';
import { PaginatedResults } from '../../record/entities/pagination/paginated-results.entity';
import { RecordSearch } from '../../record/entities/record-search.entity';
import { FieldDefinitionService } from '../../services/field-definition/field-definition.service';
import { ProfilesService } from '../../services/profiles/profiles.service';
import { OverviewOptionsService } from '../../services/store/overview-options.service';
import { Task } from '../entities/task.entity';
import { TaskService } from '../services/task.service';

@Injectable()
export class TasksSandboxService extends GenericOverviewContainerSandboxService<Task> {
    private readonly FACETS_PER_RECORD_TYPE: Map<RecordType, string[]> = new Map([]);

    constructor(
        private taskService: TaskService,
        private fieldDefinitionService: FieldDefinitionService,
        protected viewOptionsService: OverviewOptionsService,
        private profileService: ProfilesService
    ) {
        super(viewOptionsService);
    }

    getById(id: string): Observable<Task> {
        return this.taskService.getById(id);
    }

    search(recordSearch: RecordSearch): Observable<PaginatedResults<Task>> {
        return this.taskService.getAll(recordSearch);
    }

    getFieldDefinitions(): Observable<FieldDefinition[]> {
        return this.fieldDefinitionService.getAll();
    }

    getFacetProfile(tag: string): Observable<FacetProfile> {
        return this.profileService.getFacetProfileByTag(tag);
    }
}
